export default __webpack_public_path__ + "static/media/Discover.0cf979c7.svg";